import { prefixAPI } from '@resource/api';

import {
  createReceiver,
  createSender,
  createCreateWithFile,
} from '@resource/resource';

const TWO_FACTOR_REQUEST = prefixAPI('2factor/request-confirmation/')
const TWO_FACTOR_REQUEST_CONFIRM = prefixAPI('2factor/confirm/')

const REGISTRATION_CONSUMER = prefixAPI('registration/consumer/')
const REGISTRATION_DEVICE = prefixAPI('registration/device/')
const REGISTRATION_DEVICE_VALIDATE_CODE = prefixAPI('registration/device/validate-code/')
const REGISTRATION_GET_SHORT_LINK = prefixAPI('registration/short-link/get/')
const REGISTRATION_STICKS = prefixAPI('registration/sticks/')
const REGISTRATION_STICKS_CHECK_LIMIT = prefixAPI('registration/sticks/check-limit/')

// BDE device-audit lookup. Lives on the isolated BDE urlconf (apps.bde.urls) at a
// plain, un-versioned, non-language-prefixed path — so we point the sender at the
// literal URL rather than prefixAPI() (which would prepend `/{lang}/api/v1/`).
// createSender still runs it through the shared resource stack, so the xCSRF
// middleware attaches the CSRF token and non-2xx responses raise as usual.
const BDE_DEVICE_CHECK = '/api/check/'

export const make2FactorReceiver = createSender(TWO_FACTOR_REQUEST)
export const confirm2FactorReceiver = createSender(TWO_FACTOR_REQUEST_CONFIRM)

export const registrationConfirmReceiver = createSender(REGISTRATION_CONSUMER)
export const registrationDeviceReceiver = createSender(REGISTRATION_DEVICE)
export const registrationDeviceValidateCodeReceiver = createSender(REGISTRATION_DEVICE_VALIDATE_CODE)
export const registrationGetShortLinkReceiver = createSender(REGISTRATION_GET_SHORT_LINK)
export const registrationSticksReceiver = createSender(REGISTRATION_STICKS)
export const sticksLimitCheckReceiver = createSender(REGISTRATION_STICKS_CHECK_LIMIT)

export const bdeDeviceCheckReceiver = createSender(BDE_DEVICE_CHECK)

